import React, { useEffect, useState } from "react";
import { FaClipboardList } from "react-icons/fa6";
import StoreMaster from "../Comps/StoreReports/StoreMaster";
import CustomHeading from "../Comps/Extra/CustomHeading";
const pages = ["Inventory Dashboard", "Procurement Dashboard"];
const Store = () => {
  const [activePage, setActivePage] = useState("Inventory Dashboard");
  //   console.log(activePage);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div className="newUi text-center m-1 " style={{ minHeight: "90vh" }}>
      <b className="text-danger">UNDER DEVELOPMENT</b>

      <CustomHeading
        text={{
          heading: "Store",
          subText: "Store Management System",
        }}
        icon={FaClipboardList}
        style={{
          height: "100px",

          // Main container
          width: "100%",
          borderRadius: "24px",
          shadow: "0 10px 30px rgba(0,0,0,0.15)",
          background: "#fff",

          // Gradient
          gradient: true,
          color: ["#870655", "#e62e6b", "#130873"],
          gradientDirection: "120deg",

          // Heading
          headingColor: "#ffffff",
          headingSize: "clamp(2rem, 5vw, 3.5rem)",
          headingWidth: "520px",

          // Subtitle
          subtitleColor: "#f4f7fb",
          subtitleSize: "0.95rem",
          subtitleMaxWidth: "650px",
          subtitleLineHeight: 1.5,

          // Content
          contentGap: "4px",
        }}
      />
      <div className="m-1 mb-2 newUiBody">
        {pages.map((page, i) => {
          return (
            <button
              ke={i}
              className={`btn btn-outline-dark btn-sm me-1 ${activePage === page && "active"}`}
              onClick={() => {
                setActivePage(page);
              }}
            >
              {page}
            </button>
          );
        })}
      </div>
      <div className="newUiBody ">
        <StoreMaster activePage={activePage} />
      </div>
    </div>
  );
};

export default Store;
